import { HsIndexedGeometryData } from '../geometry-utils/indexed-geometry-data.class';

export function hsGenerateIndexedPlaneGeometryData(): HsIndexedGeometryData {
  const vertices: number[] = [-1, 0, -1, 1, 0, -1, 1, 0, 1, -1, 0, 1];
  const normals: number[] = [0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0];
  const indices: number[] = [0, 1, 2, 0, 2, 3];
  const uvs: number[] = [0, 0, 1, 0, 1, 1, 0, 1];
  return new HsIndexedGeometryData(vertices, normals, indices, uvs);
}
